import { Accordion } from '@mui/material';

import DeliveryCollectionCardBody from './CardBody';
import DeliveryCollectionCardHeader from './CardHeader';

import { type DeliveryAndCollectionItemState, DeliveryAndCollectionItemStateEnum } from '@/graphql/generated/graphql';

interface DeliveryItemCardProps {
  state: DeliveryAndCollectionItemState;
  uuid: string;
  onItemAction: (action: 'deploy' | 'collect', itemState: DeliveryAndCollectionItemState) => void;
}
const DeliveryItemCard: React.FC<DeliveryItemCardProps> = ({ state, uuid, onItemAction }) => {
  if (
    !state ||
    [DeliveryAndCollectionItemStateEnum.Deployed, DeliveryAndCollectionItemStateEnum.Collected].includes(
      state.currentState,
    )
  )
    return <></>;

  return (
    <Accordion>
      <DeliveryCollectionCardHeader deliveryItem={state.item} itemState={state} onItemAction={onItemAction} />
      <DeliveryCollectionCardBody deliveryItem={state.item} itemState={state} uuid={uuid} />
    </Accordion>
  );
};

export default DeliveryItemCard;
